export const SET_BLOGS = 'SET_BLOGS'
export const SET_BLOG = 'SET_BLOG'
export const SET_COMMENT = 'SET_COMMENT'
export const UPDATE_BLOG = 'UPDATE_BLOG'
export const UPDATE_COMMENT = 'UPDATE_COMMENT'
export const INIT_BLOG = 'INIT_BLOG'
export const INIT_COMMENT = 'INIT_COMMENT'
export const RESET_BLOGS = 'RESET_BLOGS'
export const RESET_COMMENTS = 'RESET_COMMENTS'
export const SET_COMMENTS = 'SET_COMMENTS'
export const RESET_ATTACHMENTS = 'RESET_ATTACHMENTS'
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS'
export const SET_FOUND_BLOGS = 'SET_FOUND_BLOGS'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_STATUS = 'SET_STATUS'
export const SET_TYPE = 'SET_TYPE'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_SORT_BY = 'SET_SORT_BY'
export const RESET_SHOW = 'RESET_SHOW'



// WEBPACK FOOTER //
// ./src/store/modules/blog/types.js